package acupoint.containers

import com.jingfangpai.api.clients.AcupointApiClient
import com.jingfangpai.common.data.model.IdName
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.acupoint.model.AcupointDetail
import com.jingfangpai.common.orm.mapping.Acupoint
import react.*
import react.dom.div
import setTitle
import acupoint.components.AcupointEdit

external interface AcupointEditPageProps : RProps {
    var id: String
}

data class AcupointEditPageContextData(
    var save: (acupoint: Acupoint, okCallback: (result: ApiResponse<Acupoint>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var getDetail: (id: String, okCallback: (result: ApiResponse<AcupointDetail>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit,
    var listIdAndName: (okCallback: (result: ApiResponse<List<IdName>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val AcupointEditPageContext = createContext(AcupointEditPageContextData(AcupointApiClient::save, AcupointApiClient::getDetail, AcupointApiClient::listIdAndName))

val AcupointEditPageProvider = functionalComponent<AcupointEditPageProps> { props ->

    setTitle("编辑穴位")

    useEffectOnce { }

    AcupointEditPageContext.Provider(AcupointEditPageContextData(AcupointApiClient::save, AcupointApiClient::getDetail, AcupointApiClient::listIdAndName)) {
        div("AcupointEditPage-page") {
            child(AcupointEdit) {
                attrs {
                    id = props.id
                }
            }
        }
    }
}
